<template>
  <div class="container">
    <div
      class="loader"
      :class="{ disabled: !isLoading, visable: isLoading }"
    ></div>
    <button
      class="LoadingButton font-size-middle"
      :type="type"
      @click="click"
      :class="{ visable: !isLoading, disabled: isLoading }"
    >
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: "LoadingButton",
  props: {
    borderColor: {
      type: String,
      default: "white",
    },
    color: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "button",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import "@/assets/scss/bulma/projectBulma.scss";

.disabled {
  display: none;
}

.visable {
  display: block;
}

.container {
  height: 40px;
}

.LoadingButton {
  user-select: none;
  font-family: "Roboto", sans-serif;
  padding: 10px 40px;
  min-width: 100px;
  background-color: transparent;
  border: solid 2px $primary;
  border-radius: 3px;
  color: $primary;
  font-weight: bold;
  outline: none;
  cursor: pointer;
}

.loader {
  width: 20px;
  margin: 1px;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.5em solid $primary;
  border-right: 0.5em solid $primary;
  border-bottom: 0.5em solid $primary;
  border-left: 0.5em solid #ffffff;
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 0.8s infinite linear;
}

.loader,
.loader:after {
  border-radius: 100%;
  width: 3em;
  height: 3em;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
